var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwitchInactive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 19,
    viewBox: "0 0 38 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.8335 18.6641L28.1668 18.6641C33.2268 18.6641 37.3335 14.5574 37.3335 9.4974C37.3335 4.4374 33.2268 0.330731 28.1668 0.330731L9.83349 0.330733C4.77349 0.330733 0.666827 4.4374 0.666827 9.4974C0.666828 14.5574 4.77349 18.6641 9.8335 18.6641ZM28.1668 3.9974C31.2102 3.9974 33.6668 6.45406 33.6668 9.4974C33.6668 12.5407 31.2102 14.9974 28.1668 14.9974C25.1235 14.9974 22.6668 12.5407 22.6668 9.4974C22.6668 6.45406 25.1235 3.9974 28.1668 3.9974Z",
    fill: "#D8D8D8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.0002,
    cy: 9.49609,
    r: 6,
    transform: "rotate(180 28.0002 9.49609)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchInactive);
export default __webpack_public_path__ + "static/media/switch-inactive.cab883a8c01003bd6f71aebb80847482.svg";
export { ForwardRef as ReactComponent };